import { React, useState, useEffect } from 'react';
import history from "../../routes/history"
import contractjobIcon from "../../assets/img/contract_job.png"
import permanentjobIcon from "../../assets/img/permanent_job.png"
import './PostGig.css'
import { Row, Col, Rate, Input, Button } from "antd";
import { useLocation } from "react-router-dom";
import { getCompanyProfileDetails } from '../../redux/actions';
import { useDispatch } from 'react-redux';
import { setCookie } from '../../shared/helpers';

export default function PostGig(props) {

  const location = useLocation();
  const dispatch = useDispatch();
  const [later,setLater] = useState(false);

  useEffect(() => {
    if (location.state) {
        setLater(true);
    }
  }, [location.state]);
  return (
    <div className='PostGig-resp'>
      <Row style={{
        display: 'flex', justifyContent: 'center', height: "90vh",
        // background: 'pink'
      }}>
        <Col xs={24} sm={24} lg={11} xl={11}
          className={"PostGig-Col"}
        >
          <div className="PostGig-Page PostGig-Page-mobile">

            <div >
              <div className="PostGig-Header">Post a gig</div>
              <div className="PostGig-desc"> Post an open job and skills you’re looking for to get matched with the best candidates for the job.
              </div>
            </div>


            <div className='PostGig-select'>Choose the gig type</div>

            <div className="PostGig-chooseJob" >
              <Col className='Contract-job' style={{ width: '48%' }} onClick={() => {history.push({
                      pathname: location?.state?.fromSignUp ? '/contract-gig' : '/postajob/choosetemplate',
                      state: {
                        Title: "",
                        FacilityName: "",
                        Skills: "",
                        Industries: "",
                        GigDuration: "",
                        Location: "",
                        Experience: "",
                        // PermanentJob: false

                      }
                    })
                    dispatch(getCompanyProfileDetails());
                    setCookie('finishProfile', 'true')
                    }}>
                <div className="PostGig-contractJob" >
                  <img src={contractjobIcon} alt="contractjobIcon" className='PostGig-jobIcon'
                    

                  />
                  <div className="PostGig-jobDivider"></div>
                  <div className="PostGig-jobText">Contract</div>
                </div>
              </Col>
              <Col className='Permanent-job'  style={{ width: '48%' }} onClick={() => {history.push({
                      pathname: location?.state?.fromSignUp ? '/per-gig' : '/postajob/choosetemplate',
                      state: {
                        Title: "",
                        FacilityName: "",
                        Skills: "",
                        Industries: "",
                        GigDuration: "",
                        Location: "",
                        Experience: "",
                        PermanentJob: true

                      }
                    })
                    dispatch(getCompanyProfileDetails());
                    setCookie('finishProfile', 'true')
                  }}>
                <div className="PostGig-permanentJob" >
                  <img src={permanentjobIcon} alt="permanentjobIcon" className='PostGig-jobIcon'

                    // onClick={()=>history.push({
                    //     pathname:'/per-gig',
                    //     state:{
                    //         Title: "",
                    //         FacilityName: "",
                    //         Skills: "",
                    //         Location: "",
                    //         Experience : "",

                    //     }
                    // })}



                  />
                  <div className="PostGig-jobDivider"></div>
                  <div className="PostGig-jobText">Permanent</div>
                </div>
              </Col>
            </div>
            {later && <Button className='Later-btn' onClick={()=>{
              history.push({
                pathname:'/allset',
                state: 'allset'
            });
            dispatch(getCompanyProfileDetails());
            }}>Skip, I’ll post a gig later</Button>}
          </div>

        </Col>
      </Row>
    </div>

  );
}